import { type OrderItem } from '@hooks-api/types/dataModel/fpOrder'

export const getSpecificAddonGroupsWithOrderDetail = (orderItems: OrderItem[]): Partial<Record<number, OrderItem[]>> => {
  return orderItems.reduce<Partial<Record<number, OrderItem[]>>>((acc, item) => {
    if (!item) return acc
    if (!item.addon_main_product_id) {
      console.warn('getSpecificAddonGroupsWithOrderDetail warning: addon_main_product_id is null', item)
      return acc
    }
    acc[item.addon_main_product_id] = [...(acc[item.addon_main_product_id] ?? []), item]
    return acc
  }, {} as Partial<Record<number, OrderItem[]>>)
}
